import {Button, styled} from "@mui/material";

export const CalendarButton = styled(Button)(({theme}) => ({
    color: theme.barekam.calendar.button.color,
    width: '100%',

    borderRadius: '1.125rem',
    border: `1px solid ${theme.barekam.calendar.button.backgroundColor}`,

    display: 'flex',
    padding: '0.25rem 1rem',

}));

export const CalendarButtonSelected = styled(CalendarButton)(({theme}) => ({
    color: theme.barekam.calendar.button.selectedColor,
    backgroundColor: theme.barekam.calendar.button.backgroundColor,

    '&:hover': {
        backgroundColor: theme.barekam.calendar.button.backgroundColor,
    }
}));

